import { Navigate, Route, Routes } from 'react-router-dom';
import { AuthProvider, useAuth } from './contexts/AuthContext';
import AppLayout from './components/AppLayout';
import LoginPage from './pages/LoginPage';
import ProjectsPage from './pages/ProjectsPage';
import ThemeDetailPage from './pages/ThemeDetailPage';
import TaskDetailPage from './pages/TaskDetailPage';
import CrmKanbanPage from './pages/CrmKanbanPage';
import CrmArchivePage from './pages/CrmArchivePage';
import ContactDetailPage from './pages/ContactDetailPage';
import PeopleFoundersPage from './pages/PeopleFoundersPage';
import PeopleExternalPage from './pages/PeopleExternalPage';
import PersonDetailPage from './pages/PersonDetailPage';
import MasterTasksPage from './pages/MasterTasksPage';
import DashboardPage from './pages/DashboardPage';
import ImportTranscriptPage from './pages/ImportTranscriptPage';
import ReviewInboxPage from './pages/ReviewInboxPage';

function ProtectedRoutes() {
  const { auth } = useAuth();
  if (auth.status === 'loading') {
    return (
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', minHeight: '100vh' }}>
        Loading…
      </div>
    );
  }
  if (auth.status === 'unauthenticated') {
    return <Navigate to="/login" replace />;
  }
  return (
    <Routes>
      <Route path="/" element={<AppLayout />}>
        <Route index element={<Navigate to="/dashboard" replace />} />
        <Route path="dashboard" element={<DashboardPage />} />
        <Route path="tasks" element={<Navigate to="/tasks/list" replace />} />
        <Route path="tasks/board" element={<MasterTasksPage />} />
        <Route path="tasks/list" element={<MasterTasksPage />} />
        <Route path="projects" element={<ProjectsPage />} />
        <Route path="projects/archive" element={<div>Archive</div>} />
        <Route path="projects/theme/:themeId" element={<ThemeDetailPage />} />
        <Route path="projects/task/:taskId" element={<TaskDetailPage />} />
        <Route path="crm" element={<CrmKanbanPage />} />
        <Route path="crm/table" element={<Navigate to="/crm" replace />} />
        <Route path="crm/archive" element={<CrmArchivePage />} />
        <Route path="crm/contact/:contactId" element={<ContactDetailPage />} />
        <Route path="people" element={<Navigate to="/people/founders" replace />} />
        <Route path="people/founders" element={<PeopleFoundersPage />} />
        <Route path="people/external" element={<PeopleExternalPage />} />
        <Route path="people/:personId" element={<PersonDetailPage />} />
        <Route path="transcripts" element={<Navigate to="/transcripts/import" replace />} />
        <Route path="transcripts/import" element={<ImportTranscriptPage />} />
        <Route path="transcripts/review" element={<ReviewInboxPage />} />
      </Route>
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

export default function App() {
  return (
    <AuthProvider>
      <Routes>
        <Route path="/login" element={<LoginRoute />} />
        <Route path="/*" element={<ProtectedRoutes />} />
      </Routes>
    </AuthProvider>
  );
}

function LoginRoute() {
  const { auth } = useAuth();
  if (auth.status === 'loading') return <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>Loading…</div>;
  if (auth.status === 'authenticated') return <Navigate to="/" replace />;
  return <LoginPage />;
}
